import { PropsWithChildren, createContext, useContext } from 'react';

export interface EnvContext {
  userToken?: string;
  mapsUrl?: string;
}

const Context = createContext<EnvContext>({});

export const EnvProvider = ({
  children,
  ...props
}: PropsWithChildren<EnvContext>) => (
  <Context.Provider value={props}>{children}</Context.Provider>
);

export const useEnvContext = () => useContext(Context);
